import { FEATURE_ACCESS, type GatedFeature } from '@/config/stripe-plans.config';
import type { Session } from '@/lib/permissions';

/**
 * Whether this visitor may use a feature that used to need Pro.
 *
 * Since credit-only pricing (2026-10) the answer depends only on being signed
 * in — `FEATURE_ACCESS` in config/stripe-plans.config.ts names the rule per
 * feature, so opening one to guests is a one-line change there. Pure: safe in
 * server routes, server components and client components alike.
 */
export function canUseFeature(session: Session | null | undefined, feature: GatedFeature): boolean {
  const access: string = FEATURE_ACCESS[feature];
  if (access === 'public') return true;
  return Boolean(session?.user);
}
